





import Vue from "vue";
import {
  CrusadeCampaignTableHeaders,
  CrusadeCampaignFormFields,
} from "@/meta/CrusadeCampaignModel";
import EntitySearchTable from "@/components/common/EntitySearchTable.vue";
import { ZealotCollections } from "@/services/MongoService";

export default Vue.extend({
  name: "CampaignTable",
  components: { EntitySearchTable },
  data: () => {
    return {
      tableHeaders: CrusadeCampaignTableHeaders,
      formFields: CrusadeCampaignFormFields,
    };
  },
  computed: {
    collection(): string {
      return ZealotCollections.CAMPAIGNS;
    },
  },
});
